module.exports = __webpack_public_path__ + "img/mail.c0cea353.svg";